<script setup lang="ts">
import type { IProductModel } from '~/interfaces/product/IProductModel';
import { money } from '~/helpers/product/productHelper';
import Slider from '~/components/sliders/Slider.vue';
import { useProductStore } from '~/store/product/productStore';
import { useVariantSelectorStore } from '~/store/variantSelectorStore';

const productStore = useProductStore();
const variantSelectorStore = useVariantSelectorStore();
const route = useRoute();
const props = defineProps<{
  productModelCollection: IProductModel[]
}>()

const {
  productModelCollection
} = toRefs(props);

const {
  selectedVariant
} = storeToRefs(variantSelectorStore)

const {
  wasOffer
} = storeToRefs(productStore)

const { t } = useI18n();

const availableModelForVariant = (modelId) => productStore.isModelAvailableForVariant(modelId)

const currentSelectedIndex = computed(() => {
  productModelCollection.value.forEach((model, index) => {
    if (model.url.includes(route.fullPath)) {
      return index;
    }
  })

  return 0;
})
const generateTitle = (modelId: number) => {
  const currentModelForVariant = availableModelForVariant(modelId);
  if (currentModelForVariant) {
    return t('www.product.model.title.online', {'minPrice': money(currentModelForVariant.price)})
  }

  return t('www.product.model.title.offline');
}

</script>

<template>
  <div class="product-model-collection-v2">
    <slider :cross-sell-items="productModelCollection" :small="true" :current-index="currentSelectedIndex">
      <div v-for="model in productModelCollection" :key="model.id" class="carousel-v2-item">
        <NuxtLink :to="(wasOffer && availableModelForVariant(model.id)) ? availableModelForVariant(model.id).link : model.url" active-class="model-active">
          <div :class="`image__container--product image image--radius ${ !availableModelForVariant(model.id) && selectedVariant !== null ? ' disable' : '' }`" :data-slider-position="model.id" :title="generateTitle(model.id)">
            <div class="image--radius image--product">
              <picture>
                <img :src="model.mainImage.imageJPG" :alt="model.id.toString()">
              </picture>
            </div>
          </div>
        </NuxtLink>
      </div>
    </slider>
  </div>
</template>

<style lang="scss">
.product-model-collection-v2 {
  .image {
    width: 80px;

    &.disable {
      position: relative;
      cursor: pointer;

      &::before {
        position: absolute;
        content: '';
        left: 0;
        bottom: 0;
        background-color: var(--background-xxlight);
        border-radius: 8px;
        opacity: .8;
        height: 100%;
        width: 100%;
        z-index: 1;
      }
    }
  }
}
</style>
